import React from "react";
import logoBlue from "../../assets/dear-logo-blue.png";
import "./styles/TrustCharter.css";

function TrustCharter() {
  return (
    <div>
      <img className="logo-charter" src={logoBlue} alt="logo Dear bleu" />
      <h1 className="chart-title">Charte de confiance </h1>
      <div className="subtitle-chart">
        <h2 className="subtitle-chart-title">
          LES ENGAGEMENTS DE LA DEAR TEAM
        </h2>
      </div>
      <p className="chart-paragraph">
        Dear c'est une application gratuite qui libère la parole et lève les
        tabous sur la sexualité. Découvrir, s'éveiller, apprendre, comprendre et
        rassurer sur l'univers de la sexualité c'est répondre à un réel enjeu
        générationnel en quête de savoir et de bien-être sexuel. Sous couverture
        d'anonymat, DEAR défend l'inclusivité, la tolérance et la bienveillance
        autour d'un sujet mis sous silence depuis trop longtemps. Dear, c'est
        une application qui avec une touche de fraîcheur et de bonne humeur
        encourage les curieux.ieuses à venir partager autour d'un sujet encore
        bien trop tabou pour la société.{" "}
      </p>
      <div className="subtitle-chart">
        <h2>ENGAGEMENT N°1 :</h2>
      </div>
      <p className="chart-paragraph">
        Vous vous êtes inscrit.es sur DEAR (gratuitement, on le rappelle !) et
        vous souhaitez échanger avec la communauté ? Poster un post ? Partager
        une expérience ? Poser une question ? Lancer un débat ? C'est OK ! Vous
        devez savoir que l'application est composée d'un algorithme (très très
        puissant haha) qui permet de bloquer vos publications si on retrouve du
        vocabulaire qui ne rentre pas dans la charte éthique de la communauté !
        Pour rappel : DEAR n'est pas un site/espace pornographique ! DEAR c'est
        une application bienveillante qui vise à développer la culture de la
        sexualité et du plaisir érotique sur des sujets encore trop tabous et à
        atteindre le bien-être sexuel.
      </p>
      <h3>Tu peux le DEAR</h3>
      <p className="chart-paragraph">
        Sexe, fesses, cul, anal, amour, vulve, vagin, pénis, fellation, sucer.
      </p>
      <h3>Tu ne peux pas le DEAR</h3>
      <p className="chart-paragraph">
        Bite, chatte, baiser, insultes, propos racistes, propos homophobes. Tout
        propos pouvant entraver la liberté des un.e.s et des autres.{" "}
      </p>
      <p className="chart-paragraph">
        Chère communauté, vous serez autorisés, grâce à vos points obtenus avec
        la gamification, à réaliser une modération pour nous venir en aide quant
        à la modération des contenus postés sur l'application.
      </p>
      <div className="subtitle-chart">
        <h2>
          ENGAGEMENT N°2: VÉRIFICATION ET VALIDATION DES PROFILS LORS DE
          L'INSCRIPTION
        </h2>
      </div>
      <p className="chart-paragraph">
        Pour faire partie de la communauté DEAR, il est indispensable d'être âgé
        au minimum de 18 ans. Le membre certifie expressément qu'il remplit
        cette condition au jour de son inscription. L'inscription est interdite
        à toute personne mineure. Au sein de notre service qualité nos
        formidables modérateur.trices sont chargé.e.s de la validation des posts
        : cohérence, copyright images, etc. Nos modérateurs.rices interviennent
        dès qu'un problème de comportement nous est signalé. Vous pouvez à tout
        moment nous signaler des problèmes de comportement d'un membre du site
        en cliquant sur les liens « signaler ce boulet » ou « signaler comme
        fake », présents sur tous les profils, ou en alertant nos
        modérateurs.trices. DEAR s'engage avec son équipe qualité à vérifier et
        analyser chacune des remontées et à prendre les mesures nécessaires,
        pouvant aller d'un simple avertissement à la radiation du profil pure et
        simple sans préavis. Le service qualité DEAR s'engage à répondre à vos
        emails sur la boîte dear.officiel@gmail.com et vos messages sur nos
        réseaux sociaux sous 72 heures. Chacune de vos notifications est
        systématiquement transférée au service concerné. Ces remarques nous
        aident à améliorer notre service chaque jour.
      </p>
      <div className="subtitle-chart">
        <h2>
          ENGAGEMENT N°3 : CONFIDENTIALITÉ, SÉCURITÉ ET PROTECTION DES DONNÉES
          PERSONNELLES
        </h2>
      </div>
      <p className="chart-paragraph">
        En accord avec la loi et les règlements en vigueur sur la protection de
        la vie privée et conformément à la Loi n°78-17 du 6 janvier 1978, dite
        Loi Informatique et Liberté, vous disposez d'un droit de consultation,
        de modification et de rectification de toute donnée personnelle portée à
        la connaissance DEAR lors de l'utilisation du service. Les coordonnées
        DEAR sont disponibles dans les informations légales. DEAR s'engage à ne
        jamais transmettre à d'autres services vos données or professionnel.les
        de la marque. Votre adresse email, votre numéro de téléphone, votre
        identité réelle sont des données strictement confidentielles qui ne
        peuvent en aucun cas être divulguées par DEAR auprès de la communauté.
      </p>
      <div className="subtitle-chart">
        <h2>ENGAGEMENT N4: UN SERVICE QUALITÉ RÉACTIF ET ACCESSIBLE</h2>
      </div>
      <p className="chart-paragraph">
        Notre service qualité d'excellence (Aline et Lila ; oui, même à deux on
        vous chouchoute !) est joignable par mail dear.officiel@gmail.com et
        clairement affiché dans les CGU. Les membres peuvent également nous
        contacter sur nos réseaux sociaux. Or, toutes les réclamations doivent
        impérativement être faites sur la boîte mail “contact”. Toute demande
        faite sur les réseaux sociaux ne sera pas prise en compte. Notre service
        s'engage à répondre aux questions (techniques et personnalisées) des
        membres sous 72h ouvrables, à traiter les litiges et à informer des
        suites données aux réclamations.
      </p>
      <div className="subtitle-chart">
        <h2>ENGAGEMENT N°5: TRANSPARENCE ET LOYAUTÉ DE DEAR</h2>
      </div>
      <p className="chart-paragraph">
        DEAR s'engage à ne pas créer de faux profils ou à utiliser de moteurs
        dans le but d'accroître artificiellement la liste des personnes qui
        interagissent sur le feed d'actualités. DEAR se veut être intègre sur la
        répartition paritaire homme-femme. Les témoignages présents sur la
        landingpage ou nos réseaux sociaux sont bien recueillis auprès de
        personnes réelles présentes sur l'application.
      </p>
      <div className="subtitle-chart">
        <h2>
          ENGAGEMENT N°6: MISE EN GARDE DES MEMBRES ET GESTION DE VOTRE
          TRANQUILLITÉ.
        </h2>
      </div>
      <p className="chart-paragraph">
        Au travers de ses règles de prudence, DEAR sensibilise sa communauté aux
        rares, mais possibles dérives de certains de ses utilisateurs peu
        scrupuleux présents sur l'application. DEAR présente une série de
        mesures et de moyens techniques pour les pointer du doigt et ils ne
        pourront plus interagir avec la communauté !
      </p>
      <div className="subtitle-chart">
        <h2>ENGAGEMENT N°7 : CLARTÉ DES INFORMATIONS D'USAGE.</h2>
      </div>
      <p className="chart-paragraph-2">
        Conditions Générales d'Utilisation DEAR sont facilement accessibles et
        rédigées dans un langage compréhensible par tous.tes. Il en va de même
        concernant les conditions d'engagement de la communauté: “DEAR ou ne pas
        DEAR”. L'inscription sur DEAR 100% gratuite et inclusive. DEAR, nouvelle
        start up, vous propose de la soutenir via vos achats dans l'onglet
        shopping. “Vous avez dépensé xx€ pour vous acheter le dernier
        vibromasseur tendance, pourquoi ne pas ajouter 1€ à votre paiement pour
        soutenir votre équipe ?"
      </p>
    </div>
  );
}

export default TrustCharter;
